.appLoading {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
}
